// The TTS voices an owner can pick for a voice-mode survey (Survey.voice) —
// soft/soothing, non-male, all available on the BE's TTS model. Labels are i18n
// (under the `conversation.` prefix the retired AI interviewer introduced).
export const VOICE_OPTIONS = [
    { value: "shimmer", labelId: "conversation.voice_shimmer", defaultLabel: "Shimmer (soft)" },
    { value: "coral", labelId: "conversation.voice_coral", defaultLabel: "Coral (warm)" },
    { value: "sage", labelId: "conversation.voice_sage", defaultLabel: "Sage (calm)" },
    { value: "nova", labelId: "conversation.voice_nova", defaultLabel: "Nova (bright)" },
];

// A stored voice that isn't offered (e.g. the BE default "alloy") reads as the first.
export const effectiveVoice = (v) => (VOICE_OPTIONS.some((o) => o.value === v) ? v : VOICE_OPTIONS[0].value);
